import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { FormTextInputProps } from './FormInputProps';
import { styled } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
}));

const _showArrows = (textFieldProps: any) => {
  if (textFieldProps && textFieldProps.showArrows === false) return false;
  return true;
};

/**
 * Form input component that accepts decimal numbers with exactly 2 decimal places.
 * Automatically ignores extra decimal places.
 */
export const FormInputDecimal = ({ name, control, label, disabled, readOnly, helperText, textFieldProps }: FormTextInputProps) => {
  const UsedTextField = _showArrows(textFieldProps) ? TextField : StyledTextField;
  
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <UsedTextField
          helperText={error ? error.message : helperText ? helperText : undefined}
          error={!!error}
          onChange={event => {
            const { value } = event.target;
            
            if (value.length > 0) {
              const normalized = value.replace(',', '.');
              if (normalized.includes('.')) {
                const parts = normalized.split('.');
                if (parts[1] && parts[1].length > 2) {
                  return; 
                }
              }
              const floatValue = parseFloat(normalized);
              if (isNaN(floatValue)) {
                onChange(null);
              } else {
                onChange(Math.round(floatValue * 100) / 100);
              }
            } else {
              onChange(null);
            }
          }}
          value={value !== null && value !== undefined ? value : ''}
          inputProps={{ inputMode: 'decimal', step: '0.01', type: 'number' }}
          fullWidth
          InputLabelProps={{
            ...(disabled ? { shrink: true } : {}),
            ...(textFieldProps && textFieldProps.InputLabelProps ? textFieldProps.InputLabelProps : {}),
          }}
          disabled={disabled || readOnly}
          label={label}
          {...textFieldProps}
        />
      )}
    />
  );
};